// extracted by mini-css-extract-plugin
export default {"tableSection":"styles_tableSection__46hHQ"};